module.exports = __webpack_public_path__ + "static/media/EXTERIOR_interface.5f8c6cfe.jpg";